import script from "./UiCloseButton.vue?vue&type=script&setup=true&lang=js"
export * from "./UiCloseButton.vue?vue&type=script&setup=true&lang=js"

import "./UiCloseButton.vue?vue&type=style&index=0&id=a9f84da8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9f84da8"]])

export default __exports__